import { Record } from "immutable";
import { MessagePartSuggestedMemory } from "models/interfaces/conversations/message-part-suggested-memory";

const defaultValues: MessagePartSuggestedMemory = {
    id: undefined,
    content: undefined,
    status: undefined,
};

export default class MessagePartSuggestedMemoryRecord
    extends Record(defaultValues)
    implements MessagePartSuggestedMemory
{
    // Do NOT set properties on immutable records due to babel and typescript transpilation issue
    // See https://github.com/facebook/create-react-app/issues/6506

    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: Partial<MessagePartSuggestedMemory>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    // #endregion Constructor

    // -----------------------------------------------------------------------------------------
    // #region Public Methods
    // -----------------------------------------------------------------------------------------

    /**
     * Merges new values into the record and returns a new instance.
     *
     * @param {Partial<MessagePartSuggestedMemory>} values
     */
    public with(
        values: Partial<MessagePartSuggestedMemory>
    ): MessagePartSuggestedMemoryRecord {
        return new MessagePartSuggestedMemoryRecord(
            Object.assign(this.toJS(), values)
        );
    }

    // #endregion Public Methods
}
